import { render, staticRenderFns } from "./JsaPDF.vue?vue&type=template&id=6d9067c1&scoped=true"
import script from "./JsaPDF.vue?vue&type=script&lang=js"
export * from "./JsaPDF.vue?vue&type=script&lang=js"
import style0 from "./JsaPDF.vue?vue&type=style&index=0&id=6d9067c1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d9067c1",
  null
  
)

export default component.exports